import {
  REGISTER_FAIL,
  REGISTER_FAIL_UNINVITED,
  USER_LOADED,
  AUTH_ERROR,
  CONFIRMATION_WAITING,
  CONFIRMATION_SUCCESS,
  CONFIRMATION_PASSWORD_ACK,
  CONFIRMATION_OLD,
  CONFIRMATION_UNKNOWN,
  CONFIRMATION_FAIL_RESENT,
  CONFIRMATION_FAIL_CHANGE,
  CONFIRMATION_FAIL_UNINVITED,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  UPDATE_PROFILE,
} from "../actions/types";

const initialState = {
  token: localStorage.getItem("token"),
  isAuthenticated: null,
  confirmationStatus: null,
  loading: true,
  user: null,
  error: null,
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case UPDATE_PROFILE:
      // UPDATE_PROFILE action will trigger two changes to state
      // - Will update profile/user state (in profile.js)
      // - Will update auth/user (in auth.js, here)*
      // * This is required given navbar functionality is governed by auth state and if we change navbar funvtionality (advanced/basic), auth state needs to change
      // Note: payload is "profile" but profile.user is populated
      return {
        ...state,
        user: payload.user,
      };
    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        confirmationStatus: null,
        loading: false,
        user: payload,
      };
    case LOGIN_SUCCESS:
      localStorage.setItem("token", payload.token);
      return {
        ...state,
        ...payload,
        confirmationStatus: null,
        isAuthenticated: true,
        loading: false,
      };
    case CONFIRMATION_WAITING:
      localStorage.removeItem("token");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        confirmationStatus: 0,
        loading: false,
        user: null,
      };
    case CONFIRMATION_SUCCESS:
      localStorage.removeItem("token");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        confirmationStatus: 1,
        loading: false,
        user: null,
      };
    case CONFIRMATION_PASSWORD_ACK:
      localStorage.removeItem("token");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        confirmationStatus: 200,
        loading: false,
        user: null,
      };
    case CONFIRMATION_OLD:
      localStorage.removeItem("token");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        confirmationStatus: 201,
        loading: false,
        user: null,
      };
    case CONFIRMATION_FAIL_UNINVITED:
      localStorage.removeItem("token");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        confirmationStatus: -101,
        loading: false,
        user: null,
      };
    case CONFIRMATION_FAIL_CHANGE:
      localStorage.removeItem("token");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        confirmationStatus: -200,
        loading: false,
        user: null,
      };
    case CONFIRMATION_FAIL_RESENT:
      localStorage.removeItem("token");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        confirmationStatus: -201,
        loading: false,
        user: null,
      };
    case CONFIRMATION_UNKNOWN:
      localStorage.removeItem("token");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        confirmationStatus: -202,
        loading: false,
        user: null,
      };
    case REGISTER_FAIL_UNINVITED:
      localStorage.removeItem("token");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        confirmationStatus: -101,
        loading: false,
        user: null,
      };
    case REGISTER_FAIL:
    case AUTH_ERROR:
    case LOGIN_FAIL:
    case LOGOUT:
      localStorage.removeItem("token");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        confirmationStatus: null,
        loading: false,
        user: null,
        error: payload,
      };
    default:
      return state;
  }
}
